import type { FC } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { Button, Stack, Typography } from '@pflegenavi/web-components';
import transferCashIcon from '../../assets/transfer-cash.svg';
import { ChangeCashMode } from './model';
import { LetterChip } from './LetterChip';

interface PayoutsFormStep1Props {
  nextStep: () => void;
  setMode: (mode: ChangeCashMode) => void;
  setIsStripeTransfer: (isStripeTransfer: boolean) => void;
  disabled?: boolean;
  disabledTooltipTitle?: string;
}

export const PayoutsFormStep1: FC<PayoutsFormStep1Props> = ({
  nextStep,
  setMode,
  setIsStripeTransfer,
  disabled,
  disabledTooltipTitle,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" gap={1} sx={{ paddingY: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LetterChip>C</LetterChip>
        <Typography variant="h6" fontWeight={700}>
          {t('cashManagement.transfer-cash-title')}
        </Typography>
      </Stack>

      <Typography variant="body2">
        <Trans
          i18nKey="cashManagement.transfer-cash-subtitle"
          components={{ bold: <strong /> }}
        />
      </Typography>

      <Stack direction="row" gap={1} justifyContent="end">
        <Tooltip title={disabled ? disabledTooltipTitle ?? '' : ''}>
          <span>
            <Button
              name={'changeCashTransferCash'}
              variant="contained"
              disabled={disabled}
              endIcon={
                <img
                  style={{
                    marginLeft: 0.5,
                    width: 17,
                  }}
                  alt=""
                  src={transferCashIcon}
                />
              }
              onClick={() => {
                setMode(ChangeCashMode.Deposit);
                setIsStripeTransfer(true);
                nextStep();
              }}
            >
              {t('cashManagement.transfer-cash')}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  );
};
